import React from 'react';

const dividerStyle = {
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center'
};

const lineStyle = {
  flex: '1 0 auto'
};

const contentStyle = {
  padding: '0 15px',
  flex: '0 0 auto'
};

class Divider extends React.Component {
  render () {
    const { props } = this;
    const { className, style, ...others } = props;
    return (
      <div className={'Divider' + (className ? ' ' + className : '')} style={dividerStyle}>
        <div className="Divider-Line" style={lineStyle}><hr /></div>
        {!props.children ? null : (
          <React.Fragment>
            <div
              className="Divider-Content"
              style={style
                ? { ...style, ...contentStyle }
                : contentStyle
              }
              {...others}
            />
            <div className="Divider-Line" style={lineStyle}><hr /></div>
          </React.Fragment>
        )}
      </div>
    );
  }
};

export default Divider;



// WEBPACK FOOTER //
// ./client/Core/Components/Divider.jsx